<template>
	<footer>
		<div class="container margin_60_35">
			<div class="row">
				<div class="col-lg-3 col-md-12">
					<p>
						<a href="index.html" title="Findoctor">
							<img src="@/assets/img/logo.png" data-retina="true" alt="" width="210" class="img-fluid" />
						</a>
					</p>
					<ul class="links ml-3">
						<li><router-link tag="a" to="/">Inicio</router-link></li>
						<li>
							<router-link tag="a" to="/about">Quienes somos</router-link>
						</li>
						<!-- <li><router-link tag="a" to="/faqs">FAQs</router-link></li> -->
						<li><router-link tag="a" to="/contact">Contacto</router-link></li>
					</ul>
				</div>

				<div class="col-lg-6 col-md-6">
					<a href="https://medicos.doctorconsultas.com/" class="btn_1 btn-register">
						<figure><img src="../assets/img/doctors_icon.svg" alt="" /></figure>
						<span>Ingreso de Médicos Especialistas</span>
					</a>
				</div>

				<div class="col-lg-3 col-md-4">
					<h5>Contactanos</h5>
					<ul class="contacts">
						<!-- <li><a href="tel://61280932400"><i class="icon_mobile"></i> + 61 23 8093 3400</a></li> -->
						<li>
							<a href="mailto:hello@doctorconsultas.com"><i class="icon_mail_alt"></i> hello@doctorconsultas.com</a>
						</li>
					</ul>
					<div class="follow_us">
						<h5>Nuestras redes</h5>
						<ul>
							<li>
								<a href="https://www.facebook.com/doctor.consultas.oficial/"><i class="social_facebook"></i></a>
							</li>
							<li>
								<a href="https://www.linkedin.com/company/doctorconsultas"><i class="social_linkedin"></i></a>
							</li>
							<li>
								<a href="https://www.instagram.com/doctor.consultas/ "><i class="social_instagram"></i></a>
							</li>
						</ul>
					</div>
					<div class="follow_us">
						<h5>Compartir</h5>

						<ul class="social-buttons">
							<li>
								<ShareNetwork
									class="social-button social-button--facebook"
									network="facebook"
									:url="shareUrl"
									:title="shareTitle"
									hashtags="DoctorConsultas"
								>
									<i class="fa fa-facebook"></i>
								</ShareNetwork>
							</li>
							<li>
								<ShareNetwork
									class="social-button social-button--twitter"
									network="twitter"
									:url="shareUrl"
									:title="shareTitle"
									hashtags="DoctorConsultas"
								>
									<i class="fa fa-twitter"></i>
								</ShareNetwork>
							</li>
							<li>
								<ShareNetwork
									class="social-button social-button--whatsapp"
									network="whatsapp"
									:url="shareUrl"
									:title="shareTitle"
									hashtags="DoctorConsultas"
								>
									<i class="fa fa-whatsapp"></i>
								</ShareNetwork>
							</li>
							<li>
								<ShareNetwork
									class="social-button social-button--mail"
									network="email"
									:url="shareUrl"
									:title="shareTitle"
									hashtags="DoctorConsultas"
								>
									<i class="fa fa-envelope"></i>
								</ShareNetwork>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-12">
					<p class="text-muted font-italic m-0 ">
						<small>* Todos los precios expresados son IVA incluído</small>
					</p>
				</div>
			</div>
			<!--/row-->
			<hr />
			<div class="row">
				<div class="col-md-4">
					<ul id="additional_links">
						<li>
							<router-link tag="a" to="/terms">Términos y condiciones</router-link>
						</li>
						<li>
							<router-link tag="a" to="/privacy">Política de privacidad</router-link>
						</li>
						<!-- <li>
              <router-link tag="a" to="/sitemap"
                >Sitemap</router-link
              >
            </li> -->
					</ul>
				</div>
				<div class="col-md-4 text-center">
					<div id="copy">© 2019 DoctorConsultas</div>
				</div>
				<div class="col-md-4 text-right">
					<img src="@/assets/img/powered-by-iwtg.png" alt="" style="width: 130px;" />
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import { ShareNetwork } from 'vue-social-sharing'

export default {
	name: 'Footer',
	props: {
		shareTitle: {
			type: String,
			default: 'Reservá tu consulta médica en DoctorConsultas',
		},
	},
	data() {
		return {
			shareUrl: 'https://doctorconsultas.com/' + this.$route.fullPath,
		}
	},
	components: {
		ShareNetwork,
	},
}
</script>

<style scoped>
/* Footer */
footer {
	background-color: #fff;
	color: #555;
	text-align: left;
}

footer h5 {
	font-size: 14px;
	font-size: 0.875rem;
	font-weight: 600;
	text-transform: uppercase;
	color: #999;
	margin-bottom: 20px;
}

@media (max-width: 767px) {
	footer h5 {
		/* For less than 767px */
		margin-bottom: 10px;
	}
}

@media (max-width: 767px) {
	footer ul {
		/* For less than 767px */
		margin-bottom: 35px;
	}
}

footer ul li {
	margin-bottom: 10px;
}

footer ul li a {
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	display: inline-block;
	position: relative;
	color: #555555;
	font-weight: 500;
}

footer ul li a:hover {
	color: #12bcec;
}

footer ul li a i {
	margin-right: 10px;
}

footer ul.links li a:hover {
	-webkit-transform: translate(5px, 0);
	-moz-transform: translate(5px, 0);
	-ms-transform: translate(5px, 0);
	-o-transform: translate(5px, 0);
	transform: translate(5px, 0);
}

footer ul.links li a:hover:after {
	opacity: 1;
}

footer ul.links li a:after {
	font-family: 'ElegantIcons';
	content: '\24';
	position: absolute;
	margin-left: 5px;
	top: 1px;
	opacity: 0;
	-moz-transition: all 0.5s ease-in-out;
	-o-transition: all 0.5s ease-in-out;
	-webkit-transition: all 0.5s ease-in-out;
	-ms-transition: all 0.5s ease-in-out;
	transition: all 0.5s ease-in-out;
}

footer ul.contacts li a i {
	margin-right: 10px;
	color: #12bcec;
}

footer #copy {
	text-align: right;
	font-size: 13px;
	font-size: 0.8125rem;
	color: #999;
}

@media (max-width: 767px) {
	footer #copy {
		/* For less than 767px */
		text-align: left;
		margin-bottom: 25px;
	}
}

.follow_us ul {
	margin: 0;
}

.follow_us ul li {
	display: inline-block;
	margin-right: 10px;
	font-size: 16px;
	font-size: 1rem;
}

.follow_us ul li a i {
	color: #555;
}

.follow_us ul li a i:hover {
	color: #12bcec;
}

/* Addtional links / Footer */
ul#additional_links {
	margin: 0;
	font-size: 13px;
	font-size: 0.8125rem;
	color: #999;
}

ul#additional_links li {
	display: inline-block;
	margin-right: 15px;
}

ul#additional_links li:first-child {
	margin-right: 20px;
}

ul#additional_links li:last-child:after {
	content: '';
}

ul#additional_links li a {
	opacity: 0.5;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
}

ul#additional_links li a:hover {
	opacity: 1;
}

ul#additional_links li:after {
	content: '|';
	font-weight: 300;
	position: relative;
	left: 10px;
}

.btn-register {
	display: flex;
	max-width: 240px;
	margin: 8px auto 16px auto;
}
.btn-register figure {
	width: 80px;
	margin: 0px;
}
.btn-register figure img {
	width: 100%;
}
.btn-register span {
	margin-left: 8px;
	font-size: 14px;
}

.social-buttons {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-top: -10px;
}
.social-buttons__button {
	margin: 10px 5px 0;
}

.social-button {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	outline: none;
	width: 40px;
	height: 40px;
	text-decoration: none;
	border-radius: 100%;
	cursor: pointer;
}
.social-button i {
	font-size: 20px;
	color: #fff !important;
	margin: 0px !important;
}

/* .social-button:focus,
.social-button:hover {
  color: #fff !important;
} */

.social-button--mail {
	color: #fff !important;
	background: #0072c6;
}

.social-button--facebook {
	color: #fff !important;
	background: #3b5999;
}
.social-button--whatsapp {
	color: #fff !important;
	background: rgb(37, 211, 102);
}

.social-button--linkedin {
	color: #0077b5;
}
.social-button--linkedin::after {
	background: #0077b5;
}
.social-button--github {
	color: #6e5494;
}
.social-button--github::after {
	background: #6e5494;
}
.social-button--codepen {
	color: #212121;
}
.social-button--codepen::after {
	background: #212121;
}
.social-button--steam {
	color: #7da10e;
}
.social-button--steam::after {
	background: #7da10e;
}
.social-button--snapchat {
	color: #eec900;
}
.social-button--snapchat::after {
	background: #eec900;
}
.social-button--twitter {
	color: #fff !important;
	background: #55acee;
}

.social-button--instagram {
	color: #e4405f;
}
.social-button--instagram::after {
	background: #e4405f;
}
</style>
